export const ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  SERVICE_WRITER: 'service_writer',
  TECHNICIAN: 'technician',
  TECH: 'tech',
  DISPATCHER: 'dispatcher',
  PARTS: 'parts',
  ACCOUNTING: 'accounting',
};

export const PERMISSIONS = {
  VIEW_WORK_ORDERS: 'view_work_orders',
  CREATE_WORK_ORDERS: 'create_work_orders',
  EDIT_WORK_ORDERS: 'edit_work_orders',
  VOID_WORK_ORDERS: 'void_work_orders',
  CLOSE_WORK_ORDERS: 'close_work_orders',
  MOVE_WORKFLOW_STAGE: 'move_workflow_stage',
  ADD_NOTES: 'add_notes',
  ADD_PHOTOS: 'add_photos',
  START_LABOR_EVENT: 'start_labor_event',
  STOP_LABOR_EVENT: 'stop_labor_event',
  VIEW_ANALYTICS: 'view_analytics',
  MANAGE_SETTINGS: 'manage_settings',
  MANAGE_ROAD_SERVICE: 'manage_road_service',
};

export const DEFAULT_ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: Object.values(PERMISSIONS),
  [ROLES.MANAGER]: [
    PERMISSIONS.VIEW_WORK_ORDERS,
    PERMISSIONS.CREATE_WORK_ORDERS,
    PERMISSIONS.EDIT_WORK_ORDERS,
    PERMISSIONS.VOID_WORK_ORDERS,
    PERMISSIONS.CLOSE_WORK_ORDERS,
    PERMISSIONS.MOVE_WORKFLOW_STAGE,
    PERMISSIONS.ADD_NOTES,
    PERMISSIONS.ADD_PHOTOS,
    PERMISSIONS.START_LABOR_EVENT,
    PERMISSIONS.STOP_LABOR_EVENT,
    PERMISSIONS.VIEW_ANALYTICS,
    PERMISSIONS.MANAGE_ROAD_SERVICE,
  ],
  [ROLES.SERVICE_WRITER]: [
    PERMISSIONS.VIEW_WORK_ORDERS,
    PERMISSIONS.CREATE_WORK_ORDERS,
    PERMISSIONS.EDIT_WORK_ORDERS,
    PERMISSIONS.MOVE_WORKFLOW_STAGE,
    PERMISSIONS.ADD_NOTES,
    PERMISSIONS.ADD_PHOTOS,
    PERMISSIONS.VIEW_ANALYTICS,
  ],
  [ROLES.TECHNICIAN]: [
    PERMISSIONS.VIEW_WORK_ORDERS,
    PERMISSIONS.MOVE_WORKFLOW_STAGE,
    PERMISSIONS.ADD_NOTES,
    PERMISSIONS.ADD_PHOTOS,
    PERMISSIONS.START_LABOR_EVENT,
    PERMISSIONS.STOP_LABOR_EVENT,
  ],
  [ROLES.TECH]: [
    PERMISSIONS.VIEW_WORK_ORDERS,
    PERMISSIONS.MOVE_WORKFLOW_STAGE,
    PERMISSIONS.ADD_NOTES,
    PERMISSIONS.ADD_PHOTOS,
    PERMISSIONS.START_LABOR_EVENT,
    PERMISSIONS.STOP_LABOR_EVENT,
  ],
  [ROLES.DISPATCHER]: [
    PERMISSIONS.VIEW_WORK_ORDERS,
    PERMISSIONS.CREATE_WORK_ORDERS,
    PERMISSIONS.EDIT_WORK_ORDERS,
    PERMISSIONS.ADD_NOTES,
    PERMISSIONS.MANAGE_ROAD_SERVICE,
  ],
  [ROLES.PARTS]: [
    PERMISSIONS.VIEW_WORK_ORDERS,
    PERMISSIONS.EDIT_WORK_ORDERS,
    PERMISSIONS.ADD_NOTES,
  ],
  [ROLES.ACCOUNTING]: [
    PERMISSIONS.VIEW_WORK_ORDERS,
    PERMISSIONS.VIEW_ANALYTICS,
  ],
};

export function normalizeRole(role) {
  return String(role || '').trim().toLowerCase();
}

export function getPermissionsForRole(role, overrides = {}) {
  const normalized = normalizeRole(role);
  const base = DEFAULT_ROLE_PERMISSIONS[normalized] || [];
  const extra = overrides[normalized] || [];
  return Array.from(new Set([...base, ...extra]));
}

export function hasPermission(role, permission, overrides = {}) {
  return getPermissionsForRole(role, overrides).includes(permission);
}

export function getCurrentRole(defaultRole = ROLES.ADMIN) {
  if (typeof window === 'undefined') return defaultRole;
  return window.localStorage.getItem('rekon_role') || defaultRole;
}

export function canCloseWorkOrder(role, overrides) {
  return hasPermission(role, PERMISSIONS.CLOSE_WORK_ORDERS, overrides);
}

export function canVoidWorkOrder(role, overrides) {
  return hasPermission(role, PERMISSIONS.VOID_WORK_ORDERS, overrides);
}

export function canMoveWorkflowStage(role, overrides) {
  return hasPermission(role, PERMISSIONS.MOVE_WORKFLOW_STAGE, overrides);
}
